import { Divide } from "lucide-react";

import ProdutoPagamentoCard from "./ProdutoPagamentoCard";
import { Button } from "../../../components/ui/button";
import { useMedidaDoItem } from "../../../hooks/useMedidaDoItem";
import { chaveItem } from "../lib/divisao";
import { brl } from "../lib/formato";

function Cabecalho({ produtos, divisaoAtiva, rotulo }) {
  const { itens, totalPago, totalMesa, onToggleTodos } = produtos;
  const abertos = itens.filter((i) => !i._paid);
  // A barra mede o quitado da conta (dinheiro + desconto já concedido); o texto separa os dois
  const gravado = Number(produtos.descontoGravado) || 0;
  const pct = totalMesa > 0 ? Math.min(100, ((totalPago + gravado) / totalMesa) * 100) : 0;
  return (
    <div className="px-4 py-3 border-b bg-muted/50 shrink-0 space-y-2">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-bold">
          {rotulo} <span className="font-normal text-muted-foreground">· {itens.length} {itens.length === 1 ? "item" : "itens"}</span>
        </p>
        {abertos.length > 1 && !divisaoAtiva && (
          <button type="button" onClick={onToggleTodos} className="text-xs text-primary hover:underline shrink-0">
            {abertos.every((i) => i._selected) ? "Desmarcar" : "Selecionar"} todos
          </button>
        )}
      </div>
      {(totalPago > 0 || gravado > 0) && (
        <div className="space-y-1">
          <div className="h-1.5 rounded-full bg-muted overflow-hidden">
            <div className="h-full bg-green-500 rounded-full" style={{ width: `${pct}%` }} />
          </div>
          <p className="text-xs text-green-600 tabular-nums">
            Pago {brl(totalPago)}{gravado > 0 ? ` + desconto ${brl(gravado)}` : ""} de {brl(totalMesa)}
          </p>
        </div>
      )}
    </div>
  );
}

function Rodape({ produtos, divisao, onAbrirDividir, doTodo }) {
  const { selecionadosQtd, selecionadosTotal } = produtos;
  if (divisao.atual) {
    return (
      <p className="text-xs text-amber-600 dark:text-amber-400">
        Conta dividida. Para escolher outros produtos, termine ou cancele a divisão ao lado.
      </p>
    );
  }
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        {selecionadosQtd > 0 ? (
          <>
            <p className="text-sm text-muted-foreground">{selecionadosQtd} selecionado(s)</p>
            <p className="text-lg font-bold text-primary tabular-nums leading-tight">{brl(selecionadosTotal)}</p>
          </>
        ) : (
          <p className="text-xs text-muted-foreground">Marque produtos para pagar ou dividir só eles. Sem marcar, o DIVIDIR divide o que falta {doTodo}.</p>
        )}
      </div>
      <Button
        type="button"
        variant="outline"
        onClick={onAbrirDividir}
        disabled={!(divisao.valorBase > 0)}
        className="h-11 px-5 shrink-0 font-bold border-amber-500/60 text-amber-600 dark:text-amber-400 hover:bg-amber-500/10"
      >
        <Divide className="w-4 h-4 mr-2" /> DIVIDIR
      </Button>
    </div>
  );
}

// Textos padrão = Fechar mesa; a retirada do Delivery passa os dela
const TEXTOS_MESA = { produtos: "Produtos da mesa", inteira: "Mesa inteira", doTodo: "da mesa inteira" };

export default function ListaProdutosPagamento({ produtos, divisao, getImageUrl, textos, onAbrirDividir }) {
  const t = { ...TEXTOS_MESA, ...textos };
  const medida = useMedidaDoItem(); // quilo/litro pelo cadastro (30/09/2026)
  const atual = divisao.atual;
  const naDivisao = (item) => !!atual && chaveItem(item) in atual.base;
  // Não pagos primeiro: o que falta cobrar fica no topo em comanda comprida
  const ordenados = [...produtos.itens.filter((i) => !i._paid), ...produtos.itens.filter((i) => i._paid)];

  return (
    <div className="flex-1 min-h-0 md:flex-none md:w-1/2 xl:w-[44%] flex flex-col md:border-r">
      <Cabecalho produtos={produtos} divisaoAtiva={!!atual} rotulo={t.produtos} />
      <div className="flex-1 min-h-0 overflow-y-auto p-2 md:p-3">
        {produtos.extraTopo || null}
        <div className="space-y-2">
          {ordenados.map((item) => (
            <ProdutoPagamentoCard
              key={chaveItem(item)}
              item={item}
              naDivisao={naDivisao(item)}
              onToggle={() => produtos.onToggle(produtos.itens.indexOf(item))}
              onQtd={(qtd) => produtos.onQtd(produtos.itens.indexOf(item), qtd)}
              getImageUrl={getImageUrl}
              medida={medida(item)}
              rodape={produtos.rodapeItem ? produtos.rodapeItem(item) : null}
            />
          ))}
        </div>
      </div>
      {/* No celular o DIVIDIR e o valor ficam na barra de pagamento fixa */}
      <div className="hidden md:block px-4 py-3 border-t bg-muted/50 shrink-0">
        <Rodape produtos={produtos} divisao={divisao} onAbrirDividir={onAbrirDividir} doTodo={t.doTodo} />
      </div>
    </div>
  );
}
